import React, { useState, useEffect, Suspense } from 'react'; // Suspense ensures that lazy-loaded components render correctly. lazy components come from ./routes
import { Route, Routes, Link } from 'react-router-dom';
import routes from "./routes";
import ServitechLogoColor from './svg/ServiTechColor.svg'
import { ApiUtils } from 'utils';
import config from './config'

import 'bootstrap/dist/css/bootstrap.min.css'
import './styles.css'
import LoginComponent from './LoginComponent';

const AppWrapper = () => {

    const [userEmail, setUserEmail] = useState("");
    const [userToken, setUserToken] = useState("");
    const [userVerified, setUserVerified] = useState(false);
    const [userAccessDenied, setUserAccessDenied] = useState(false);
    const [loginLoading, setLoginLoading] = useState(false);
    const [user, setUser] = useState({
        email: '',
        isManager: false,
        division: ''
    })

    const handleLogOut = async (e) => {
        if (e) {
            e.preventDefault()
        }
        clearEmailToken()
        clearAccessToken()
        setUserVerified(false)
    }

    const getEmployeeAccessForUser = async (email) => {
        try {
            if (email) {
                const getEmployeeAccessQuery = `
                    query GetAccessByEmail($Service: String!, $Email_VC: String!) {
                        getAccessByEmail(Service: $Service, Email_VC: $Email_VC) {
                            EmployeeAccess_BT
                        }
                    }
                `;
                const employeeAccessVars = {
                    Service: "Employees",
                    Email_VC: email
                };
                const access = await ApiUtils.gqlQueryWithVars('getAccessByEmail', getEmployeeAccessQuery, employeeAccessVars)
                return access?.EmployeeAccess_BT || false
            }
            return false;
        } catch (error) { console.log(error); return false }
    }

    const getEmail = () => {
        const email = localStorage.getItem('email');
        return (email);
    }
    const setEmail = (email) => {
        localStorage.setItem('email', email);
        setUserEmail(email);
    }

    const clearEmailToken = () => {
        localStorage.removeItem('email');
        setUserEmail("");
    }

    const getAccessToken = () => {
        const token = localStorage.getItem('token');
        return (token);
    }
    const setAccessToken = (token) => {
        localStorage.setItem('token', token);
    }

    const clearAccessToken = () => {
        localStorage.removeItem('token');
        setUserToken("")
    }

    const handleGetDivision = async () => {
        if (userEmail) {
            const getInfoFromEmailQuery = `
                query GetPersonByEmail($Email_VC: String!) {
                    getPersonByEmail(Email_VC: $Email_VC) {
                        Division_ID
                        EmployeeAccess_BT
                        IsManager_BT
                    }
                }
            `;
            const infoFromEmailVars = {
                Email_VC: userEmail
            };


             const personInfo = await ApiUtils.gqlQueryWithVars('getPersonByEmail', getInfoFromEmailQuery, infoFromEmailVars)
             console.log('access response', personInfo)
            if (personInfo) {
                setUser({
                    division: personInfo.Division_ID,
                    email: userEmail,
                    isManager: personInfo.IsManager_BT
                })
                setUserVerified(personInfo.EmployeeAccess_BT)
                setLoginLoading(false)
                if (!personInfo.EmployeeAccess_BT) {
                    setUserAccessDenied(true)
                    handleLogOut()
                }
            }
        }
    }

    const email = getEmail();
    const token = getAccessToken();

    useEffect(() => {
        if (token) {
            setUserToken(token);
        }
    }, [token]);

    useEffect(() => {
        if (email) {
            setUserEmail(email);
        }
    }, [email]);

    useEffect(() => {
        handleGetDivision();
    }, [userEmail])

    return (
        <div style={{ height: "100vh" }}>
            <nav className="navbar ST-navbar fixed-top">
                <div className="container-fluid">
                    <div>
                        {/* eslint-disable-next-line */}
                        <a className="navbar-brand me-0" href="#"><img src={ServitechLogoColor} height="35px" /></a>
                    </div>
                    <div className="service-title">{`Employee Manager ${config.env === 'staging' ? 'STAGING' : ''}`}</div>
                    <div className="pe-0">
                        {/* eslint-disable-next-line */}
                        <a className="navbar-nav" data-bs-toggle="dropdown">
                            <i className="bi bi-three-dots" style={{ "fontSize": "1.5rem", "color": "#000000", "cursor": "pointer" }}></i>
                        </a>
                        <ul className="me-0 dropdown-menu dropdown-menu-end">

                            <li><a className="dropdown-item" href="https://employee-directory-bjudfyf5za-uc.a.run.app/">Employee Directory</a></li>
                            <li><a className="dropdown-item" href={config.urls.assets}>Asset Manager</a></li>
                            <li><a className="dropdown-item" href="https://cropfile.servitech.com">The Crop File</a></li>
                            <li><a className="dropdown-item" href="https://labreports.servitechlabs.com/">Lab Reports</a></li>
                            <li><a className="dropdown-item" href="https://intranet.servitech.com">ServiTech Intranet</a></li>

                            <li><hr className="dropdown-divider" /></li>

                            <li className="dropdown-item" onClick={(e) => { handleLogOut(e); setUserAccessDenied(false) }}><Link to="/login" style={{ color: "black", textDecoration: "none" }}>Logout</Link></li>

                        </ul>
                    </div>
                </div>
            </nav>
            <div className="content-routes">
                <Suspense fallback={<div>Loading...</div>}> {/* <-- this line prevents React from throwing an error while waiting for the import to resolve. */}
                    <Routes>
                        {routes.map(({ path, component: Component }) =>
                        (
                            <Route key={path} path={path} element={(userEmail && userToken && userVerified) ? <Component
                                setEmail={setEmail}
                                setAccessToken={setAccessToken}
                                getEmail={getEmail}
                                getAccessToken={getAccessToken}
                                user={user}
                                setUserAccessDenied={setUserAccessDenied}
                                getEmployeeAccessForUser={getEmployeeAccessForUser}
                                handleLogOut={handleLogOut}
                            /> : <LoginComponent
                                setEmail={setEmail}
                                setAccessToken={setAccessToken}
                                getEmail={getEmail}
                                getAccessToken={getAccessToken}
                                userAccessDenied={userAccessDenied}
                                getEmployeeAccessForUser={getEmployeeAccessForUser}
                                setUserAccessDenied={setUserAccessDenied}
                                loginLoading={loginLoading}
                                setLoginLoading={setLoginLoading}
                            />} />
                        )
                        )}
                    </Routes>
                </Suspense>
            </div>
        </div>
    );
}

export default AppWrapper;
